import { useEffect, useState } from 'react';
export var GiveawayEvent;
(function (GiveawayEvent) {
    GiveawayEvent["Started"] = "giveaway::started";
    GiveawayEvent["Ended"] = "giveaway::ended";
})(GiveawayEvent || (GiveawayEvent = {}));
export const useSetupGiveawayListeners = (giveaway) => {
    const [currentGiveaway, setCurrentGiveaway] = useState(giveaway);
    const handleGiveawayStarted = (newGiveaway) => {
        setCurrentGiveaway(newGiveaway);
        window.dispatchEvent(new CustomEvent(GiveawayEvent.Started, {
            detail: {
                giveaway: newGiveaway,
            },
        }));
    };
    const handleGiveawayFinished = (endedGiveaway) => {
        setCurrentGiveaway(undefined);
        window.dispatchEvent(new CustomEvent(GiveawayEvent.Ended, {
            detail: {
                giveaway: endedGiveaway,
            },
        }));
    };
    useEffect(() => {
        if (giveaway && !currentGiveaway) {
            handleGiveawayStarted(giveaway);
        }
        else if (currentGiveaway && !giveaway) {
            handleGiveawayFinished(currentGiveaway);
        }
    }, [giveaway]);
};
